import DealerRegister from "../services/register.service";
import {LOGIN_FAIL, REGISTER_SUCCESS, SET_MESSAGE} from "./types";

export const dealerRegister = (companyTitle,
                               taxAdministration,
                               taxNumber,
                               city,
                               district,
                               dealerAddress,
                               storeLink,
                               hasTradeAuthorizationCertificate,
                               tradeAuthorizationCertificateNumber,
                               tradeAuthorizationCertificateDate,
                               companyOwnerName,
                               companyOwnerSurname,
                               tcNo,
                               birtdate,
                               email,
                               mobilePhone,
                               phoneNumber,
                               companyManagerName,
                               companyManagerSurname,
                               companyManagerTcNo,
                               companyManagerBirtdate,
                               membershipContract,
                               disclosure,
                               dataProcess,
                               etkPermission,
                               password,
                               againPassword,
                               createDate) => (dispatch) => {
    return DealerRegister.register(companyTitle, taxAdministration, taxNumber, city, district, dealerAddress, storeLink, hasTradeAuthorizationCertificate, tradeAuthorizationCertificateNumber, tradeAuthorizationCertificateDate, companyOwnerName, companyOwnerSurname, tcNo, birtdate, email, mobilePhone, phoneNumber, companyManagerName, companyManagerSurname, companyManagerTcNo, companyManagerBirtdate, membershipContract, disclosure, dataProcess, etkPermission, password,
        againPassword).then(
        (data) => {
            dispatch({
                type: REGISTER_SUCCESS,
                payload: {user: data},
            });

            return Promise.resolve(data);
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: LOGIN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject(message);
        }
    );
};

